import Utils from '../../../../Utils';
import classes from './Container.module.css';

export default function Container({ visible = true, children, title, style }) {
    return <div className={Utils.getClasses(classes.container, !visible && classes.hidden)} style={style}>
        {/* {title && <div className={classes.heading}>{title}</div>} */}
        {children}
        <div style={{ height: '10px', flex: 'none' }} />
    </div>
}